export const offerAssesmentValue = {
    "group": "assesment",
    "subGroup": {
        "information": "information",
    },
    "field": {
        "uuid": "uuid",
        "offer": "offer",
        "items": "items",
    }
}